module.exports = __webpack_public_path__ + "img/zarzadzanie-poziomem.173c1169.jpg";